export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const UPDATE_MOVIES_FAVORITE = 'UPDATE_MOVIES_FAVORITE';
export const UPDATE_MOVIES_WILL_WATCH = 'UPDATE_MOVIES_WILL_WATCH';
export const FETCH_GENRES = 'FETCH_GENRES';
export const FETCH_GENRES_SUCCESS = 'FETCH_GENRES_SUCCESS';
export const FETCH_GENRES_ERROR = 'FETCH_GENRES_ERROR';
export const FETCH_MOVIES = 'FETCH_MOVIES';
export const FETCH_MOVIES_SUCCESS = 'FETCH_MOVIES_SUCCESS';
export const FETCH_MOVIES_ERROR = 'FETCH_MOVIES_ERROR';
export const SET_SORT_BY = 'SET_SORT_BY';
export const SET_CURRENT_YEAR = 'SET_CURRENT_YEAR';
export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export const SET_SELECTED_GENRES = 'SET_SELECTED_GENRES';
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';
export const FETCH_MOVIE_BY_ID = 'FETCH_MOVIE_BY_ID';
export const FETCH_MOVIE_BY_ID_SUCCESS = 'FETCH_MOVIE_BY_ID_SUCCESS';
export const FETCH_MOVIE_BY_ID_ERROR = 'FETCH_MOVIE_BY_ID_ERROR';
export const CLEAR_CURRENT_MOVIE = 'CLEAR_CURRENT_MOVIE';
export const FETCH_MOVIE_VIDEOS_BY_ID = 'FETCH_MOVIE_VIDEOS_BY_ID';
export const FETCH_MOVIE_VIDEOS_BY_ID_SUCCESS = 'FETCH_MOVIE_VIDEOS_BY_ID_SUCCESS';
export const FETCH_MOVIE_VIDEOS_BY_ID_ERROR = 'FETCH_MOVIE_VIDEOS_BY_ID_ERROR';
export const FETCH_MOVIE_ACTORS_BY_ID = 'FETCH_MOVIE_ACTORS_BY_ID';
export const FETCH_MOVIE_ACTORS_BY_ID_SUCCESS = 'FETCH_MOVIE_ACTORS_BY_ID_SUCCESS';
export const FETCH_MOVIE_ACTORS_BY_ID_ERROR = 'FETCH_MOVIE_ACTORS_BY_ID_ERROR';
export const CLEAR_ALL_USER_DATA = 'CLEAR_ALL_USER_DATA';